// src/App.js
import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import LoginPage from './pages/LoginPage';
import MenuPage from './pages/MenuPage';
import TrafegoPage from './pages/TrafegoPage';
import Setor2Page from './pages/Setor2Page';
import Setor3Page from './pages/Setor3Page';
import Setor4Page from './pages/Setor4Page';
import Setor5Page from './pages/Setor5Page';
import Setor6Page from './pages/Setor6Page';
import Setor7Page from './pages/Setor7Page';
import AdminUsuarios from './pages/AdminUsuarios';

// ✅ penalizações: caminho correto informado por você
import PenalizacaoPanel from './components/penalizacao/PenalizacaoPanel';

// Provider do tema
// ❌ REMOVIDO - já está em index.js para evitar duplicação
// import { ThemeModeProvider } from './context/ThemeContext';

const queryClient = new QueryClient();

/* ========================= Helpers / Guards ========================= */
function getUser() {
  try { return JSON.parse(sessionStorage.getItem('user') || '{}'); } catch { return {}; }
}
function isLoggedIn() {
  const u = getUser();
  return !!u?.username;
}
function canView(tab) {
  const u = getUser();
  if (u?.isSuper) return true;                  // Joziel tem acesso total
  const tabs = Array.isArray(u?.allowedTabs) ? u.allowedTabs : [];
  return tabs.includes(tab);
}
function canManageUsers() {
  const u = getUser();
  return !!u?.isSuper || !!u?.canManageUsers;   // Joziel ou quem tem a chavinha
}

// Exige login
function RequireAuth({ children }) {
  if (!isLoggedIn()) return <Navigate to="/" replace />;
  return children;
}

// Exige permissão para uma aba específica
function RequireTab({ tab, children }) {
  if (!isLoggedIn()) return <Navigate to="/" replace />;
  return canView(tab) ? children : <Navigate to="/menu" replace />;
}

// Exige permissão de administração de usuários
function RequireAdmin({ children }) {
  if (!isLoggedIn()) return <Navigate to="/" replace />;
  return canManageUsers() ? children : <Navigate to="/menu" replace />;
}
/* =================================================================== */

function AppContent() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Menu (precisa estar logado) */}
      <Route
        path="/menu"
        element={
          <RequireAuth>
            <MenuPage />
          </RequireAuth>
        }
      />

      {/* Setor 1: Operação (Tráfego) */}
      <Route
        path="/trafego"
        element={
          <RequireTab tab="operacao">
            <TrafegoPage />
          </RequireTab>
        }
      />

      {/* Setor 1: Penalizações (usando o componente informado) */}
      <Route
        path="/penalizacoes"
        element={
          <RequireTab tab="penalizacao">
            <PenalizacaoPanel />
          </RequireTab>
        }
      />

      {/* Setor 2 – Compras */}
      <Route
        path="/setor2"
        element={
          <RequireTab tab="setor2">
            <Setor2Page />
          </RequireTab>
        }
      />

      {/* Setor 3 – Manutenção */}
      <Route
        path="/setor3"
        element={
          <RequireTab tab="setor3">
            <Setor3Page />
          </RequireTab>
        }
      />

      {/* Setor 4 – Arrecadação */}
      <Route
        path="/setor4"
        element={
          <RequireTab tab="setor4">
            <Setor4Page />
          </RequireTab>
        }
      />

      {/* Setor 5 – TI */}
      <Route
        path="/setor5"
        element={
          <RequireTab tab="setor5">
            <Setor5Page />
          </RequireTab>
        }
      />

      {/* Setor 6 – Jurídico */}
      <Route
        path="/setor6"
        element={
          <RequireTab tab="setor6">
            <Setor6Page />
          </RequireTab>
        }
      />

      {/* Setor 7 – Estratégico */}
      <Route
        path="/setor7"
        element={
          <RequireTab tab="setor7">
            <Setor7Page />
          </RequireTab>
        }
      />

      {/* Administração de usuários */}
      <Route
        path="/admin/usuarios"
        element={
          <RequireAdmin>
            <AdminUsuarios />
          </RequireAdmin>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
